export default __webpack_public_path__ + "e8c6cbf3981891cd052e5a0c2896ea6b.png";